module.exports = "https://web-assets.ifttt.com/packs/media/home/meet-new-ifttt-9bcc75bc.jpg";